var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ceiling-wrap"},[_c('span',{staticClass:"copy-writing-text",on:{"click":_vm.handleAccept}},[_vm._v(_vm._s(_vm.copywriting))]),_vm._v(" "),_c('div',{staticClass:"iconfont iconcha",on:{"click":_vm.closeShowSuction}})])
}
var staticRenderFns = []

export { render, staticRenderFns }